import Cookies from 'js-cookie';
import { devError } from '../utils';
function getVarKey(appName) {
    return `${appName}Config`;
}
const SafeCookies = Cookies.withConverter({
    write(value, name) {
        let parsedValue = value;
        try {
            const obj = typeof value === 'string' ? JSON.parse(value) : value;
            if (typeof obj !== 'object') {
                throw new Error('Cookie could not be converted to object');
            }
            parsedValue = JSON.stringify(obj);
        }
        catch (e) {
            devError('Could not convert cookie (write)', String(e));
        }
        return Cookies.converter.write(parsedValue, name);
    },
    read(value, name) {
        return Cookies.converter.read(value, name);
    },
});
function getCookieValue(key) {
    if (!document) {
        throw new Error('Can not access document object to get cookie value');
    }
    return SafeCookies.get(key) ?? null;
}
function setCookieValue(key, value) {
    if (!document) {
        throw new Error('Can not access document object to set cookie value');
    }
    SafeCookies.set(key, value);
    return true;
}
export function readDynamicConfig(appName, readValue) {
    try {
        const key = getVarKey(appName);
        const value = readValue ? readValue(key) : getCookieValue(key);
        return value ? JSON.parse(value) : {};
    }
    catch (e) {
        devError('Failed to read dynamic config', String(e));
        return {};
    }
}
export function writeDynamicConfig(appName, config, writeValue) {
    try {
        const key = getVarKey(appName);
        const value = JSON.stringify(config);
        const success = writeValue
            ? writeValue(key, value)
            : setCookieValue(key, value);
        if (!success) {
            throw new Error('Could not write value');
        }
        return true;
    }
    catch (e) {
        devError('Failed to write dynamic config', String(e));
        return false;
    }
}
export function injectDynamicConfig(config, readValue) {
    if (!config.debug) {
        return config;
    }
    const dynamicConfig = readDynamicConfig(config.appName, readValue);
    const newConfig = config;
    if (dynamicConfig.themeType) {
        newConfig.themeType = dynamicConfig.themeType;
    }
    if (Array.isArray(dynamicConfig.selectedTestGroupProfile) &&
        dynamicConfig.selectedTestGroupProfile.length > 0) {
        newConfig.permission.selectedTestGroupProfile =
            dynamicConfig.selectedTestGroupProfile;
    }
    if (Array.isArray(dynamicConfig.selectedTestGroups) &&
        dynamicConfig.selectedTestGroups.length > 0) {
        newConfig.permission.selectedTestGroups = dynamicConfig.selectedTestGroups;
    }
    if (Array.isArray(dynamicConfig.selectedTestOrganisationUnits) &&
        dynamicConfig.selectedTestOrganisationUnits.length > 0) {
        newConfig.permission.selectedTestOrganisationUnits =
            dynamicConfig.selectedTestOrganisationUnits;
    }
    return newConfig;
}
